import MessageCircleWhatsappIcon from '@components/v2/icons/MessageCircleWhatsapp';
import Modal from '@components/v2/ui/Modal/Modal';
import { Grid } from '@mui/material';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import LangEnum from '../../lang/LangEnum';
import { useTranslation } from '../translation/TranslationContext';

type WithoutLicenseModalProps = {
  open: boolean;
  message?: string | null;
  onClose: () => void;
  onExited?: () => void;
  onClickExpand: () => void;
};

const WithoutLicenseModal = ({
  open,
  message = `Você não possui licenças disponíveis, solicitamos que você entre em contato com o administrador do sistema.`,
  onClose,
  onExited,
  onClickExpand,
}: WithoutLicenseModalProps) => {
  const { translate } = useTranslation();

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={open}
      size="standard"
      header={{ title: translate(LangEnum.MY_NETWORK_WITHOUT_LICENSE_MODAL_TITLE) }}
      onClose={handleClose}
      footer={{
        primaryAction: {
          label: LangEnum.MY_NETWORK_WITHOUT_LICENSE_MODAL_EXPAND_MY_NETWORK,
          startIcon: MessageCircleWhatsappIcon,
          onClick: onClickExpand,
        },
        secondaryAction: {
          label: LangEnum.MY_NETWORK_WITHOUT_LICENSE_MODAL_MAYBE_LATER,
          onClick: onClose,
        },
      }}
      onExited={onExited}
    >
      <Container maxWidth="xs" disableGutters>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Typography align="justify">{message}</Typography>
          </Grid>
        </Grid>
      </Container>
    </Modal>
  );
};

export default WithoutLicenseModal;
